// How an e-pass on a booking stands, worded the same in Manage Bookings and the owner portal.
// Mirrors BookingEpassDto on the backend.

export const EPASS_UPLOADED = "UPLOADED";
export const EPASS_PENDING = "PENDING";
// Applying needs the vehicle number, so nothing can be done before driver and vehicle are assigned.
export const EPASS_WAITING = "WAITING_FOR_VEHICLE";
export const EPASS_NOT_NEEDED = "NOT_NEEDED";

export const EPASS_ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp";
export const EPASS_MAX_BYTES = 10 * 1024 * 1024;

export function epassStatusLabel(status) {
  if (status === EPASS_UPLOADED) return "Uploaded";
  if (status === EPASS_NOT_NEEDED) return "Not needed";
  if (status === EPASS_WAITING) return "After driver & vehicle";
  return "Pending";
}

export function epassStatusVariant(status) {
  if (status === EPASS_UPLOADED) return "success";
  if (status === EPASS_NOT_NEEDED || status === EPASS_WAITING) return "secondary";
  return "danger";
}

/** Uploaded or not needed - nothing left to do for it. */
export function epassDone(epass) {
  return epass?.status === EPASS_UPLOADED || epass?.status === EPASS_NOT_NEEDED;
}

/** Why a picked file cannot be sent, or "" when it is fine. */
export function epassFileProblem(file) {
  if (!file) return "Choose the e-pass file.";
  if (file.size > EPASS_MAX_BYTES) return "The e-pass file must be under 10 MB.";
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();
  const allowed = ["application/pdf", "image/jpeg", "image/jpg", "image/png", "image/webp"].includes(type)
    || /\.(pdf|jpe?g|png|webp)$/.test(name);
  return allowed ? "" : "The e-pass must be a PDF, JPG, PNG or WEBP file.";
}
